<template>
  <div class="ui-menu field">
    <label
      v-if="label"
      class="mb-2 label no-select"
    >
      <h3>{{ label }}</h3>
    </label>
    <p
      v-if="hasHelpText"
      class="help-text"
      v-html="finalHelpText"
    ></p>
    <VueSelect
      :id="`${name}-type`"
      :options="typeOptions"
      :value="type"
      @change="type = $event"
    />
    <Menu
      v-if="type === 'custom'"
      :label="customMenuLabel"
      :help-text="customMenuHelpText"
      :name="name"
    />
    <template v-else-if="type === 'global'">
      <VueSelect
        v-show="menuOptions.length"
        :id="`${name}-global`"
        :options="menuOptions"
        :value="menu"
        label="Selecionar menu global"
        @change="menu = $event"
      />
      <button
        v-if="selectedGlobalMenu"
        class="btn btn-secondary"
        :disabled="isViewerUser"
        @click="editGlobalData({ globalId: menu, modelPath })"
      >
        <span>Editar menu selecionado</span>
      </button>
      <button
        v-if="selectedGlobalMenu"
        class="btn btn-secondary btn-white"
        :disabled="isViewerUser"
        @click="
          addGlobalData({ baseGlobalData: selectedGlobalMenu, modelPath })
        "
      >
        <span>Duplicar menu selecionado</span>
      </button>
      <button
        class="btn btn-secondary btn-white"
        :disabled="isViewerUser"
        @click="
          addGlobalData({
            baseGlobalData: {
              module: 'GlobalMenu',
              name: 'Menu Global',
            },
            modelPath,
          })
        "
      >
        <span>Criar novo menu global</span>
      </button>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Menu from '@/ui-types/Menu.vue';
import VueSelect from '@/ui-types/VueSelect.vue';
import isObject from '@/helpers/isObject';
import commonProperties from './common-properties';

export default {
  name: 'MenuSelect',
  components: {
    Menu,
    VueSelect,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    customMenuLabel: {
      type: String,
      default: '',
    },
    customMenuHelpText: {
      type: String,
      default: '',
    },
    customMenuDefault: {
      type: Array,
      default: () => [
        {
          linkText: 'Promoções',
          linkUrl: {
            type: 'externalLink',
            value: '',
            openInNewTab: true,
          },
          menuLinks: [],
        },
      ],
    },
  },
  data() {
    return {
      typeOptions: [
        {
          label: 'Sem menu',
          value: '',
        },
        {
          label: 'Customizado',
          value: 'custom',
        },
        {
          label: 'Global',
          value: 'global',
        },
      ],
    };
  },
  computed: {
    type: {
      get() {
        if (Array.isArray(this.menu)) {
          return 'custom';
        }
        return typeof this.menu === 'string' ? 'global' : '';
      },
      set(newValue) {
        if (newValue === 'custom') {
          if (this.model && this.model.custom) {
            this.menu = this.model.custom;
          } else {
            this.menu = this.customMenuDefault;
          }
        } else if (newValue === 'global') {
          this.menu = '';
        } else {
          this.menu = undefined;
        }
      },
    },
    menu: {
      get() {
        return isObject(this.model) ? this.model.globalReference : this.model;
      },
      set(newValue) {
        let value = newValue;

        // If it's an array, therefore a custom menu, save it the way it is
        // if it's not, see if it was an array then save it in the custom property
        // if it wasn't, just spread if it was an object, or save the value inside an object
        if (!Array.isArray(value)) {
          if (Array.isArray(this.model)) {
            value = { globalReference: value, custom: this.model };
          } else {
            value = isObject(this.model)
              ? { ...this.model, globalReference: value }
              : { globalReference: value };
          }
        }

        this.model = value;
      },
    },
    selectedGlobalMenu() {
      return typeof this.menu === 'string' && this.menus[this.menu];
    },
    menuOptions() {
      const menuOptions = Object.entries(this.menus).map(
        ([key, { title }]) => ({
          value: key,
          label: title,
        }),
      );

      // Shows a select advising that the menu once selected here wasn't found
      if (!this.selectedGlobalMenu) {
        menuOptions.unshift({
          value: this.menu,
          label: this.menu
            ? 'Menu não encontrado' // Not found state
            : 'Selecione um menu', // Empty state
        });
      }

      return menuOptions;
    },
    ...mapGetters(['menus', 'isViewerUser']),
  },
  methods: {
    ...mapActions(['addGlobalData', 'editGlobalData']),
  },
};
</script>

<style scoped lang="scss">
.ui-menu {
  h3 {
    font-weight: $lb-medium;
    font-size: $size-small;
    line-height: 1.5;
    color: $dark;
  }

  .help-text {
    margin-top: 0;
    margin-bottom: 20px;
    line-height: 14px;
  }

  .btn {
    width: 100%;
    justify-content: center;
    margin-top: 12px;
  }

  .label {
    display: flex;
    align-items: center;

    .btn {
      margin: 0 0 0 auto;
      font-size: $size-smaller;
      padding: 6px 8px;
      width: auto;

      .icon {
        font-size: inherit;
      }

      span {
        margin-left: 4px;
        line-height: 1;
      }
    }
  }
}
</style>
